import { selectIsAutobrokerEnabled } from './selectIsAutobrokerEnabled';

import { createSelector } from 'reselect';
import { selectAuctionBet } from '../../reducers/v2/promotion/selectors/selectAuctionBet';

export const selectIsAuctionEnabled = createSelector(
  [selectAuctionBet, selectIsAutobrokerEnabled],
  (auction, isAutobrokerEnabled): boolean => {
    return Boolean(auction?.available && !isAutobrokerEnabled);
  },
);
